
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import Configure from '../../revobase/localization/Configure';

@Component({
  components: { Configure },
})
export default class TabLocalization extends Vue {
}
